import React, { useState, useEffect } from 'react';
import './Legal.css';

function Privacy() {
  const [html, setHtml] = useState('');
  const [title, setTitle] = useState('Privacy Policy');
  const [updated, setUpdated] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchFromSlug = (slug) =>
    fetch(`/api/cms/${slug}`)
      .then(r => r.json())
      .then(data => data?.content || null)
      .catch(() => null);

  useEffect(() => {
    setLoading(true);
    // Try primary slug first, fall back to legacy slug if empty
    fetchFromSlug('privacy-policy')
      .then(async c => {
        if (c?.content) return c;
        return fetchFromSlug('privacy'); // fallback for old editor saves
      })
      .then(c => {
        if (c?.content) {
          setHtml(c.content);
          setTitle(c.page_title || 'Privacy Policy');
          if (c.updated_at) {
            setUpdated(new Date(c.updated_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }));
          }
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>{title}</h1>
        {updated && <p className="last-updated">Last Updated: {updated}</p>}
      </div>
      <div className="legal-content">
        {loading
          ? <p style={{ color: '#666', padding: '40px 0' }}>Loading...</p>
          : <div dangerouslySetInnerHTML={{ __html: html }} />
        }
      </div>
    </div>
  );
}

export default Privacy;

